import { Box } from '@mui/material';

const RatingBadge = ({ rating }) => (
	<Box
		className="w-7 h-7 rounded-full flex items-center justify-center font-bold text-sm border-2 border-investor-deep text-investor-deep"
		sx={{ backgroundColor: '#00D175' }}>
		{rating}
	</Box>
);

export default RatingBadge;
